// routes
import { paths } from 'src/routes/paths';
// components
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export const navConfig = [
  {
    title: 'Home',
    icon: <Iconify icon="eva:home-fill" />,
    path: '/',
  },
  {
    title: 'How It Works',
    icon: <Iconify icon="eva:info-fill" />,
    path: paths.howItWorks,
  },
  {
    title: 'For Restaurants',
    icon: <Iconify icon="eva:shopping-bag-fill" />,
    path: paths.forRestaurants,
  },
  {
    title: 'For Suppliers',
    icon: <Iconify icon="eva:shopping-cart-fill" />,
    path: paths.forSuppliers,
  },
  // {
  //   title: 'About Us',
  //   icon: <Iconify icon="eva:people-fill" />,
  //   path: paths.aboutUs,
  // },
  {
    title: 'Features',
    icon: <Iconify icon="eva:star-fill" />,
    path: paths.features,
  },
  {
    title: 'Blog & News',
    icon: <Iconify icon="eva:file-text-fill" />,
    path: paths.blog,
  },
  {
    title: 'FAQ',
    icon: <Iconify icon="eva:question-mark-circle-fill" />,
    path: paths.faq,
  },
  {
    title: 'Contact Us',
    icon: <Iconify icon="eva:message-circle-fill" />,
    path: paths.contact,
  },
];
